window.VT_CART_V = 1;

/*
  Why this file exists at all:

  Dawn's CartDrawer.renderContents() does
      this.querySelector('.drawer__inner').classList.remove('is-empty')
  but cart-drawer.liquid puts `is-empty` on the <cart-drawer> HOST element,
  not on .drawer__inner. So after an add-to-cart from an EMPTY cart the host
  keeps `is-empty`, and component-cart-drawer.css keeps the header at
  display:none (cart-drawer.is-empty .drawer__header). The drawer opens with
  no title and a broken grid layout until a full page reload.

  Fix: watch #CartDrawer for content swaps and derive `is-empty` from the
  markup that is actually re-rendered (.drawer__inner-empty only exists when
  cart == empty).

  Second, smaller job: replay the Gratisversand fill transition after a
  re-render, since innerHTML replacement gives a brand-new element that would
  otherwise paint at its final width with no animation.
*/

(function () {
  'use strict';

  function syncEmptyClass(host) {
    host.classList.toggle('is-empty', !!host.querySelector('.drawer__inner-empty'));
  }

  function replayFill(host) {
    var fill = host.querySelector('.vt-cart__fill');
    if (!fill) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = fill.style.width;
    if (!target) return;

    fill.style.width = '0%';
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        fill.style.width = target;
      });
    });
  }

  function boot() {
    var host = document.querySelector('cart-drawer');
    if (!host) return;

    var target = host.querySelector('#CartDrawer') || host;
    var pending = false;

    syncEmptyClass(host);
    replayFill(host);

    if (typeof window.MutationObserver !== 'function') return;

    new window.MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        syncEmptyClass(host);
        replayFill(host);
      });
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
